<template>
  <div class="content">
    <div class="header-overlay"></div>
    <div class="footer-overlay"></div>
    <div class="content-info">
      <div class="info-slot left">
        <v-icon>lightbulb_outline</v-icon>
        <span>{{ storiesFoundFeedback }}</span>
      </div>

      <div class="info-slot right">
        <v-btn text icon title="atualizar">
          <v-icon>refresh</v-icon>
        </v-btn>
      </div>
    </div>

    <div
      class="story-list"
      v-show="drawer && stories.news && stories.news.length > 0"
    >
      <CardList
        @setSelectedStory="selectSimilarStory"
        @loadMoreNews="loadNews"
        :news="stories.news"
        :isLoading="isLoading"
        :homeContentMode="0"
        :inSidebarTab="true"
      >
      </CardList>
    </div>
    <Error
      v-show="!stories.news || stories.news.length === 0"
      :textTitle="'Tão <span>vazio</span> por aqui...'"
      :textDescription="
        'Não encontramos nenhuma retranca similar ao conteúdo atual.'
      "
      :imageTitle="'bored'"
      class="empty-search inside"
    />
    <LoadingOverlay :enabled="isLoading || isWaitingMoreConflicts" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CardList from '@/components/stories/CardList.vue';
import Error from '@/components/shared/Error.vue';
import LoadingOverlay from '../../shared/LoadingOverlay.vue';

export default {
  components: {
    CardList,
    Error,
    LoadingOverlay,
  },
  props: {
    stories: Object,
    isLoading: Boolean,
    drawer: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('news', ['isWaitingMoreConflicts']),
    storiesFoundFeedback() {
      const storiesLength = this.stories.total;
      if (storiesLength === 0) return 'Nenhuma retranca similar encontrada';
      if (storiesLength === 1)
        return `encontramos ${storiesLength} retranca similar`;
      return `encontramos ${storiesLength} retrancas similares`;
    },
  },

  methods: {
    loadNews(story) {
      this.$emit('load-more-stories', story);
    },
    selectSimilarStory(story) {
      this.$emit('select-similar-story', story);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/content-panel.scss';
</style>
